import {
  Badge,
  Button,
  CssBaseline,
  Grid,
  IconButton,
  Paper,
  Snackbar,
  Tooltip,
  useMediaQuery,
  useTheme
} from "@mui/material";
import React, { useContext, useEffect, useMemo, useState } from "react";
import {
  LicenseInfo,
  DataGridPro,
  GridToolbarColumnsButton,
  GridToolbarDensitySelector,
  getGridStringOperators,
  getGridDateOperators
} from "@mui/x-data-grid-pro";
import { CommonService } from "../../services";
import ChipInfoList from "../common/ChipInfoList";
import { LoggedInUserDetails } from "../common/LoggedInUserDetails/LoggedInUserDetails";
import Alert from "@mui/lab/Alert";
import RefreshIcon from "@mui/icons-material/Refresh";
import { CustomFilters } from "../common/CustomFilters/CustomFilters";
import CustomReportIcon from "@mui/icons-material/Archive";
import useStyles from "../common/CommonStyle/CommonStyle";
import { FormattedMessage, useIntl } from "react-intl";
import GridTextLocalization from "../common/GridTextLocalization/GridTextLocalization";
import { SupportedLanguageDetails } from "../common/SupportedLanguageDetails/SupportedLanguageDetails";
import CommonGridPagination from "../common/CommonGridPagination/CommonGridPagination";
import { ModuleAccessPermissionKey } from "../../Constants/ModuleAccessKey";
import IconMessage from "@mui/icons-material/Forum";
import CustomBreadCrumb from "../common/CustomBreadCrumb";
import IconApproval from "@mui/icons-material/LibraryAddCheck";
import CancelIcon from "@mui/icons-material/Cancel";
import GetAppIcon from "@mui/icons-material/GetApp";
import CommonBackDrop from "../common/BackDrop";
import IconAdvanceShipmentNoteOutbound from "@mui/icons-material/Receipt";
import { GlobalEdiApiConstants } from "../../Constants/GlobalEdiApiConstants";
import CommonReportDownloadForMsg from "../common/CommonReportDownloadForMsg";
import CustomFilterComponent, {
  GetFilterableColumns
} from "../common/CustomFilterComponent";
import FilterListIcon from "@mui/icons-material/FilterList";
import { manageUserPreferences } from "../../services/manageUserPreferences";
import ExcelIcon from "../ForecastTransmission/ExcelIcon.svg";
import saveAs from "file-saver";
import { Controller, set, useForm } from "react-hook-form";

const columnFieldsName = {
  //Forecast Transmission
  fcId: "fcId",
  poNumber: "poNumber",
  bpCode: "bpCode",
  bpName: "bpName",
  entityName: "entityName",
  msgStatusFlag: "msgStatusFlag",
  msgSentRemarks: "msgSentRemarks",
  createdTime: "createdDt",
  emailSendDt: "emailSendDt",
  // rejectionFlag: "rejectionFlag",
  fileName: "fileName",
  remarks: "remarks",
  erpEntityCode: "entity.erpEntityCode",
  wbsCode: "wbsCode",
  fileReceivedDate: "fileReceivedDt",
  // emailSentStatus:'emailSentStatus',
  forecastDt: "forecastDt",
  revisionDt: "revisionDt",
  createdBy: "createdBy",
  updatedTime: "updatedTime",
  updatedBy: "updatedBy",
  approved: "approved",
  approvedBy: "approvedBy",
  approvedDate: "approvedDt",
  erpOrgCode: "organization.erpOrgCode",
  fileReceivedfromDate: "fileReceivedfromDate",
  fileReceivedtoDate: "fileReceivedtoDate"
};

function ForecastTransmission(props) {
  const classes = useStyles();
  const intl = useIntl();
  const theme = useTheme();
  const X_GRID_LICENSE_KEY = `${process.env.REACT_APP_X_GRID_LICENSE_KEY}`.toString();
  LicenseInfo.setLicenseKey(X_GRID_LICENSE_KEY);
  const selectedLanguage = useContext(SupportedLanguageDetails);
  const localtext = GridTextLocalization();
  const apiUrlAndParamBodyConstants = GlobalEdiApiConstants();
  const pageLabelsConstantsAndMessages = {
    alignment: {
      alignLeft: "left",
      alignRight: "right",
      alignCenter: "center"
    }
  };

  const [selectedRow, setSelectedRow] = React.useState([]);
  const moduleAccessKeyPermission = ModuleAccessPermissionKey();
  const { loggedInUserInfo } = useContext(LoggedInUserDetails);
  const advanceShipmentNoteOutboundModuleAccess =
    loggedInUserInfo.roleModuleAccess[
      moduleAccessKeyPermission.advanceShipmentNoteOutbound
    ];
  const [alertBoxState, setAlertBoxState] = React.useState({
    openAlert: false,
    vertical: "top",
    horizontal: "center",
    message: "",
    severity: ""
  });
  const [openBackDrop, setOpenBackDrop] = useState(false);
  const handleCloseAlert = () => {
    setAlertBoxState({ ...alertBoxState, openAlert: false });
  };
  const mobileScreen = useMediaQuery(theme.breakpoints.down("md"));
  const { vertical, horizontal, openAlert, message, severity } = alertBoxState;
  const [refreshTable, setRefreshTable] = useState(false);
  const [tableLoadingStatus, setTableLoadingStatus] = useState(false);
  const [totalRowCount, setTotalRowCount] = useState(0);
  const [chipInfoList, setChipInfoList] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [columns, setColumns] = useState([]);
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);
  const [disableApproveButton, isDisableApproveButton] = useState(true);
  const [
    disiablingDownloadButtonForZeroRecords,
    setDisiablingDownloadButtonForZeroRecords
  ] = useState(false);
  const [searchedApprovedRecords, setSearchedApprovedRecords] = useState("");
  const [searchedEmailStatusRecords, setSearchedEmailStatusRecords] = useState(
    true
  );
  const [keyValueData, setKeyValueData] = useState({});
  const [searchedFromDt, setSearchedFromDt] = useState("");
  const [searchedToDt, setSearchedToDt] = useState("");
  const [isRowSentForApproval, setIsRowSentForApproval] = useState(false);
  var defaultEntity = loggedInUserInfo.defaultEntity;
  const [searchedShipToCustomerName, setSearchedShipToCustomerName] = useState(
    ""
  );
  const [searchedShipmentNumber, setSearchedShipmentNumber] = useState("");
  const [msgHdrPopUp, setMsgHdrPopUp] = useState(false);
  const [
    searchedApprovedRecordsRecords,
    setSearchedApprovedRecordsRecords
  ] = useState(null);
  const [searchedCommType, setSearchedCommType] = useState("");
  const [searchedMsgAsnSentFromDt, setSearchedMsgAsnSentFromDt] = useState("");
  const [searchedMsgAsnSentToDt, setSearchedMsgAsnSentToDt] = useState("");
  const [
    searchedShipmentCreatedByUserName,
    setSearchedShipmentCreatedByUserName
  ] = useState("");
  const [disableRejectionButton, isDisableRejectionButton] = useState(true);

  const [searchedPoNo, setSearchedPoNo] = useState("");
  const [searchedEntityName, setSearchedEntityName] = useState("");
  const [searchedCreatedBy, setSearchedCreatedBy] = useState("");
  const [searchedCreatedTime, setSearchedCreatedTime] = useState("");
  const [searchedUpdatedBy, setSearchedUpdatedBy] = useState("");
  const [searchedUpdatedTime, setSearchedUpdatedTime] = useState("");
  const [searchedEmailSentDate, setSearchedEmailSentDate] = useState("");
  const [searchedMsgStatus, setSearchedMsgStatus] = useState("");
  const [searchedApproved, setSearchedApproved] = useState("");
  const [searchedApprovedBy, setSearchedApprovedBy] = useState("");
  const [searchedApprovedDate, setSearchedApprovedDate] = useState("");
  const [searchedWbsCode, setSearchedWbsCode] = useState("");
  const [searchedForecastDate, setSearchedForecastDate] = useState("");
  const [searchedRevisionDate, setSearchedRevisionDate] = useState("");
  const [searchedMsgStatusremarks, setSearchedMsgStatusRemarks] = useState("");
  const [searchedRemarks, setSearchedRemarks] = useState("");
  const [searchedFileName, setSearchedFileName] = useState("");
  const [
    searchedfileReceivedfromDate,
    setSearchedfileReceivedfromDate
  ] = useState("");
  const [searchedfileReceivedtoDate, setSearchedfileReceivedtoDate] = useState(
    ""
  );

  const forecastTransmissionModuleAccess =
    loggedInUserInfo.roleModuleAccess[
      moduleAccessKeyPermission.forecastTransmission
    ];
  const [searchedBpCode, setsearchedBpCode] = useState("");
  const [searchedBillToCustomerName, setSearchedBillToCustomerName] = useState(
    ""
  );
  const [searchedErpEntityCode, setSearchedErpEntityCode] = useState("");
  const [searchedFileReceivedData, setSearchedFileReceivedDate] = useState("");
  const [
    searchedFcFileRecievedFromDt,
    setSearchedFcFileRecievedFromDt
  ] = useState("");
  const [searchedFcFilereceivedToDt, setSearchedFcFilereceivedToDt] = useState(
    ""
  );

  const [openFilterPanel, setFilterPanel] = useState(false);
  const handleClose = () => {
    setFilterPanel(false);
  };
  const [filterCount, setFilterCount] = React.useState(0);

  const defaulSelectedFilters =
    defaultEntity !== ""
      ? [
          {
            columnField: columnFieldsName.erpEntityCode,
            headerName: "Ent. Code",
            id: 0,
            operatorValue: "contains",
            value: defaultEntity
          }
        ]
      : [];

  const [selectedFilters, setSelectedFilters] = useState(defaulSelectedFilters);

  const [
    isIntialDefaultEntityFilter,
    setIsIntialDefaultEntityFilter
  ] = useState(defaultEntity !== "" ? true : false);

  const {
    handleSubmit,
    formState: { errors },
    reset,
    control,
    setValue
  } = useForm({
    mode: "all",
    reValidateMode: "onChange",
    defaultValues: {
      process: "",
      createdDt: "",
      //generatedFromDt: "",
      //generatedToDt: "",
      approved: ""
    }
  });

  const [paramBody, setParamBody] = useState({
    body: {
      entity: {
        erpEntityCode: ""
      },
      recordApprovedStatus: "All",
      recordApprSentStatus: "All",
      recordEmailSentDate: "All",
      recordStatusFlag: "All"
    },
    pageNo: 0,
    sortDir: "desc",
    sortKey: "createdDt",
    recordsPerPage: 25
  });

  const insert = (arr, index, newItems) => [
    ...arr.slice(0, index),
    newItems,
    ...arr.slice(index)
  ];

  const [
    callSaveApiForOrderVisibility,
    setCallSaveApiForOrderVisibility
  ] = useState(false);
  const [callSaveApiForSorting, setCallSaveApiForSorting] = useState(false);
  const [preference, setPreference] = useState(
    apiUrlAndParamBodyConstants.paramBodyForGetListApis.userPreference
  );
  const [pinnedColumns, setPinnedColumns] = useState({
    left: ["__check__"],
    right: []
  });
  const [callSaveApiForPinning, setCallSaveApiForPinning] = useState(false);
  const [callSaveApiForFilter, setCallSaveApiForFilter] = useState(false);
  const [intialParamBodyApiCall, setIntialParamBodyApiCall] = useState(false);
  const disableAuthorizationBasedOnTheRoleAccess =
    forecastTransmissionModuleAccess !== undefined
      ? forecastTransmissionModuleAccess.createFlag ||
        forecastTransmissionModuleAccess.editFlag
      : false;

  function orderAndHideColumns(savedUserPreference, defaultUserPreference) {
    if (
      savedUserPreference.length !== 0 &&
      defaultUserPreference.length !== 0
    ) {
      var orderedUserPreferences = [],
        len = defaultUserPreference.length,
        len_copy = len,
        index,
        current;

      for (; len--; ) {
        current = defaultUserPreference[len];
        index = savedUserPreference.findIndex(
          element => element.field === current.field
        );
        orderedUserPreferences[index] = current;
        orderedUserPreferences[index].hide = savedUserPreference[index].hide;
      }

      Array.prototype.splice.apply(
        defaultUserPreference,
        [0, len_copy].concat(orderedUserPreferences)
      );
      return orderedUserPreferences;
    }
  }

  const savePreference = (preferenceChangeIn, params, orderedColumns) => {
    if (preferenceChangeIn === "filter") {
      setCallSaveApiForFilter(true);
      setPreference(prev => ({ ...prev, columnsFilter: params }));
    } else if (preferenceChangeIn === "sort") {
      setCallSaveApiForSorting(true);
      setPreference(prev => ({
        ...prev,
        columnsSort: { field: params.field, sort: params.sort }
      }));
    } else if (
      preferenceChangeIn === "visibility" ||
      preferenceChangeIn === "order"
    ) {
      var splicedFirstColumn = params;
      if (params[0].field === "__check__")
        splicedFirstColumn = params.splice(1, params.length);
      setCallSaveApiForOrderVisibility(true);
      setPreference(prev => ({
        ...prev,
        columnsOrdervisible: splicedFirstColumn
      }));
    } else if (preferenceChangeIn === "pinned") {
      setCallSaveApiForPinning(true);
      setPreference(prev => ({
        ...prev,
        columnsOrdervisible: orderedColumns,
        columnsPinned: params
      }));
    }
  };

  useEffect(() => {
    manageUserPreferences
      .saveLastOpenedScreen(componentList[1].name.props.id)
      .then(response => {})
      .catch(function(error) {
        if (error.response !== undefined) {
          setAlertBoxState({
            ...alertBoxState,
            openAlert: true,
            message: error.response.data.message,
            severity: "error"
          });
        }
      });
  }, []);

  useEffect(() => {
    if (callSaveApiForPinning === false)
      preference.columnsPinned = pinnedColumns;
    if (callSaveApiForFilter === false)
      preference.columnsFilter = selectedFilters;
    if (
      callSaveApiForOrderVisibility === false &&
      callSaveApiForPinning === false
    )
      preference.columnsOrdervisible = columns;
    if (callSaveApiForSorting === false)
      preference.columnsSort = {
        field: paramBody.sortKey,
        sort: paramBody.sortDir
      };
    if (
      (callSaveApiForFilter === true ||
        callSaveApiForPinning === true ||
        callSaveApiForOrderVisibility === true ||
        callSaveApiForSorting === true) &&
      (preference.columnsOrdervisible !== undefined &&
        preference.columnsOrdervisible !== null &&
        preference.columnsOrdervisible.length !== 0 &&
        preference.columnsSort.field !== "")
    ) {
      manageUserPreferences
        .saveGridPreferences({
          userId: 0,
          organization: {},
          entity: {},
          screenName: componentList[1].name.props.id,
          tabName: componentList[1].name.props.id,
          preferences: JSON.stringify(preference),
          lastOpen: true
        })
        .then(response => {
          if (callSaveApiForOrderVisibility === true) {
            var defaultColumns = columns;
            var userChangedColumns = preference.columnsOrdervisible;
            var userPreferedColumns = orderAndHideColumns(
              userChangedColumns,
              defaultColumns
            );
            setColumns(userPreferedColumns);
            setCallSaveApiForOrderVisibility(false);
          } else if (callSaveApiForSorting === true) {
            setCallSaveApiForSorting(false);
          } else if (callSaveApiForPinning === true) {
            setPinnedColumns(preference.columnsPinned);
            setColumns(preference.columnsOrdervisible);
            setCallSaveApiForPinning(false);
          } else if (callSaveApiForFilter === true) {
            setCallSaveApiForFilter(false);
          }
        })
        .catch(function(error) {
          if (error.response !== undefined) {
            setAlertBoxState({
              ...alertBoxState,
              openAlert: true,
              message: error.response.data.message,
              severity: "error"
            });
          }
        });
    }
  }, [preference]);

  const componentList = [
    {
      path: undefined,
      name: <FormattedMessage id="common.menu.breadcrumb.message" />,
      iconName: IconMessage
    },
    {
      path: "/forecastTransmission",
      name: (
        <FormattedMessage id="common.module.breadcrumb.forecastTransmission" />
      ),
      iconName: IconAdvanceShipmentNoteOutbound
    }
  ];

  const commonColumnForForecastTransmission = [
    {
      field: "file",
      headerName: intl.formatMessage({ id: "columnname.file.label" }),
      width: 100,
      sortable: false,
      hide: false,
      headerAlign: `${pageLabelsConstantsAndMessages.alignment.alignCenter}`,
      align: `${pageLabelsConstantsAndMessages.alignment.alignCenter}`,
      filterable: false,
      renderHeader: CommonService.customRenderHeaderColumns,
      renderCell: cellParams => (
        <div>
          {cellParams.row.downloadCsvFilePath !== null && (
            <Tooltip
              title={
                <FormattedMessage
                  id="common.tooltip.breadcrumb.downloadExcel"
                  defaultMessage="downloadExcel"
                />
              }
              placement="bottom"
              className={classes.actionButton}
              onClick={() => {
                showDownloadExcel(cellParams.row.downloadCsvFilePath);
              }}
            >
              <span>
                <IconButton className={classes.customeToolbar} size="large">
                  <img
                    icon
                    src={ExcelIcon}
                    className={classes.ExcelIconPO}
                    alt="ExcelIcon"
                    color="primary"
                    size="10"
                  />
                </IconButton>
              </span>
            </Tooltip>
          )}
        </div>
      )
    },
    {
      field: columnFieldsName.erpEntityCode,
      headerName: intl.formatMessage({ id: "common.EntityCode.label" }),
      headerAlign: `${pageLabelsConstantsAndMessages.alignment.alignCenter}`,
      align: `${pageLabelsConstantsAndMessages.alignment.alignLeft}`,
      width: 100,
      sortable: false,
      type: "string",
      hide: false,
      filterable: true,
      valueGetter: params => `${params.row.entity.erpEntityCode}`,
      renderHeader: CommonService.customRenderHeaderColumns
    },
    {
      field: columnFieldsName.bpCode,
      headerName: intl.formatMessage({ id: "columnname.bpCode.label" }),
      headerAlign: `${pageLabelsConstantsAndMessages.alignment.alignCenter}`,
      align: `${pageLabelsConstantsAndMessages.alignment.alignLeft}`,
      width: 120,
      sortable: true,
      type: "string",
      hide: false,
      filterable: true,
      renderHeader: CommonService.customRenderHeaderColumns
    },
    {
      field: columnFieldsName.bpName,
      headerName: intl.formatMessage({ id: "columnName.bpname.label" }),
      headerAlign: `${pageLabelsConstantsAndMessages.alignment.alignCenter}`,
      align: `${pageLabelsConstantsAndMessages.alignment.alignLeft}`,
      width: 260,
      sortable: false,
      type: "string",
      hide: false,
      filterable: false,
      renderHeader: CommonService.customRenderHeaderColumns
    },
    {
      field: columnFieldsName.wbsCode,
      headerName: intl.formatMessage({ id: "columnname.wbscode.label" }),
      headerAlign: `${pageLabelsConstantsAndMessages.alignment.alignCenter}`,
      align: `${pageLabelsConstantsAndMessages.alignment.alignLeft}`,
      width: 150,
      sortable: true,
      type: "string",
      hide: false,
      filterable: true,
      renderHeader: CommonService.customRenderHeaderColumns
    },
    {
      field: columnFieldsName.fileName,
      headerName: intl.formatMessage({ id: "columnName.fileName.label" }),
      headerAlign: `${pageLabelsConstantsAndMessages.alignment.alignCenter}`,
      align: `${pageLabelsConstantsAndMessages.alignment.alignLeft}`,
      width: 350,
      sortable: false,
      type: "string",
      hide: false,
      filterable: false,
      renderHeader: CommonService.customRenderHeaderColumns
    },
    {
      field: columnFieldsName.fileReceivedDate,
      headerName: intl.formatMessage({
        id: "columnName.fileReceivedDate.label"
      }),
      headerAlign: `${pageLabelsConstantsAndMessages.alignment.alignCenter}`,
      align: `${pageLabelsConstantsAndMessages.alignment.alignLeft}`,
      width: 220,
      sortable: true,
      type: "string",
      hide: false,
      filterable: false,
      renderHeader: CommonService.customRenderHeaderColumns,
      renderCell: cellParams => <span>{cellParams.row.fileReceivedDtDisp}</span>
    },
    {
      field: columnFieldsName.forecastDt,
      width: 150,
      headerName: intl.formatMessage({ id: "columnname.forecastDate.label" }),
      sortable: true,
      headerAlign: `${pageLabelsConstantsAndMessages.alignment.alignCenter}`,
      align: `${pageLabelsConstantsAndMessages.alignment.alignLeft}`,
      type: "string",
      hide: false,
      filterable: false,
      renderHeader: CommonService.customRenderHeaderColumns
    },
    {
      field: columnFieldsName.revisionDt,
      width: 150,
      headerName: intl.formatMessage({ id: "columnname.revisionDate.label" }),
      sortable: true,
      headerAlign: `${pageLabelsConstantsAndMessages.alignment.alignCenter}`,
      align: `${pageLabelsConstantsAndMessages.alignment.alignLeft}`,
      type: "string",
      hide: false,
      filterable: false,
      renderHeader: CommonService.customRenderHeaderColumns
    },
    {
      field: columnFieldsName.approved,
      width: 150,
      headerName: intl.formatMessage({ id: "columnName.approved.label" }),
      sortable: true,
      headerAlign: `${pageLabelsConstantsAndMessages.alignment.alignCenter}`,
      align: `${pageLabelsConstantsAndMessages.alignment.alignCenter}`,
      type: "string",
      hide: true,
      filterable: false,
      renderHeader: CommonService.customRenderHeaderColumns,
      renderCell: CommonService.ApproveFailureChipsForPO
    },
    {
      field: columnFieldsName.approvedBy,
      headerName: intl.formatMessage({ id: "columnName.approvedBy.label" }),
      headerAlign: `${pageLabelsConstantsAndMessages.alignment.alignCenter}`,
      align: `${pageLabelsConstantsAndMessages.alignment.alignCenter}`,
      width: 160,
      sortable: false,
      type: "string",
      hide: true,
      filterable: false,
      renderHeader: CommonService.customRenderHeaderColumns
    },
    {
      field: columnFieldsName.approvedDate,
      headerName: intl.formatMessage({ id: "columnName.approvedDate.label" }),
      headerAlign: `${pageLabelsConstantsAndMessages.alignment.alignCenter}`,
      align: `${pageLabelsConstantsAndMessages.alignment.alignLeft}`,
      width: 170,
      sortable: true,
      type: "dateTime",
      hide: true,
      filterable: false,
      renderHeader: CommonService.customRenderHeaderColumns,
      renderCell: cellParams => <span>{cellParams.row.approvedDtDisp}</span>
    },
    {
      field: columnFieldsName.msgStatusFlag,
      width: 200,
      headerName: intl.formatMessage({
        id: "columnName.emailSentStatus.label"
      }),
      sortable: true,
      headerAlign: `${pageLabelsConstantsAndMessages.alignment.alignCenter}`,
      align: `${pageLabelsConstantsAndMessages.alignment.alignCenter}`,
      type: "string",
      hide: false,
      filterable: false,
      renderHeader: CommonService.customRenderHeaderColumns,
      renderCell: CommonService.SuccessFailureChipsForFCTransmission
    },
    {
      field: columnFieldsName.emailSendDt,
      width: 150,
      headerName: intl.formatMessage({ id: "columnName.emailSentDate.label" }),
      sortable: true,
      headerAlign: `${pageLabelsConstantsAndMessages.alignment.alignCenter}`,
      align: `${pageLabelsConstantsAndMessages.alignment.alignLeft}`,
      type: "string",
      hide: false,
      filterable: false,
      renderHeader: CommonService.customRenderHeaderColumns,
      renderCell: cellParams => <span>{cellParams.row.emailSentDtDisp}</span>
    },
    {
      field: columnFieldsName.msgSentRemarks,
      width: 200,
      headerName: intl.formatMessage({
        id: "columnName.msgSentStatusRemarks.label"
      }),
      sortable: false,
      headerAlign: `${pageLabelsConstantsAndMessages.alignment.alignCenter}`,
      align: `${pageLabelsConstantsAndMessages.alignment.alignLeft}`,
      type: "string",
      hide: true,
      filterable: false,
      renderHeader: CommonService.customRenderHeaderColumns
    },
    {
      field: columnFieldsName.remarks,
      headerName: intl.formatMessage({ id: "remarks.tablecell" }),
      headerAlign: `${pageLabelsConstantsAndMessages.alignment.alignCenter}`,
      align: `${pageLabelsConstantsAndMessages.alignment.alignLeft}`,
      width: 330,
      sortable: false,
      type: "string",
      hide: false,
      filterable: false,
      renderHeader: CommonService.customRenderHeaderColumns
    },
    /* {
      field: columnFieldsName.createdBy,
      headerName: intl.formatMessage({
        id: "columnname.columnnamecreatedby.label"
      }),
      headerAlign: `${pageLabelsConstantsAndMessages.alignment.alignCenter}`,
      align: `${pageLabelsConstantsAndMessages.alignment.alignLeft}`,
      width: 150,
      sortable: false,
      type: "string",
      hide: false,
      filterable: false,
      renderHeader: CommonService.customRenderHeaderColumns
    },
    {
      field: columnFieldsName.createdTime,
      headerName: intl.formatMessage({ id: "columnname.createddate.label" }),
      headerAlign: `${pageLabelsConstantsAndMessages.alignment.alignCenter}`,
      align: `${pageLabelsConstantsAndMessages.alignment.alignLeft}`,
      width: 180,
      sortable: true,
      type: "string",
      hide: false,
      filterable: false,
      renderHeader: CommonService.customRenderHeaderColumns,
      renderCell: cellParams => <span>{cellParams.row.createdDtDisp}</span>
    },*/
    {
      field: columnFieldsName.updatedBy,
      headerName: intl.formatMessage({ id: "columnname.updatedby.label" }),
      headerAlign: `${pageLabelsConstantsAndMessages.alignment.alignCenter}`,
      align: `${pageLabelsConstantsAndMessages.alignment.alignLeft}`,
      width: 155,
      sortable: false,
      type: "string",
      hide: true,
      filterable: false,
      renderHeader: CommonService.customRenderHeaderColumns
    },
    {
      field: columnFieldsName.updatedTime,
      headerName: intl.formatMessage({ id: "columnname.updateddate.label" }),
      headerAlign: `${pageLabelsConstantsAndMessages.alignment.alignCenter}`,
      align: `${pageLabelsConstantsAndMessages.alignment.alignLeft}`,
      width: 180,
      sortable: true,
      type: "string",
      hide: true,
      filterable: false,
      renderHeader: CommonService.customRenderHeaderColumns
    },
    {
      field: columnFieldsName.fileReceivedfromDate,
      headerName: intl.formatMessage({
        id: "columnname.filereceivedfromdata.label"
      }),
      headerAlign: `${pageLabelsConstantsAndMessages.alignment.alignCenter}`,
      align: `${pageLabelsConstantsAndMessages.alignment.alignLeft}`,
      width: 180,
      sortable: false,
      type: "string",
      hide: true,
      filterable: true,
      renderHeader: CommonService.customRenderHeaderColumns
    },
    {
      field: columnFieldsName.fileReceivedtoDate,
      headerName: intl.formatMessage({
        id: "columnname.filereceivedtodata.label"
      }),
      headerAlign: `${pageLabelsConstantsAndMessages.alignment.alignCenter}`,
      align: `${pageLabelsConstantsAndMessages.alignment.alignLeft}`,
      width: 180,
      sortable: false,
      type: "string",
      hide: true,
      filterable: true,
      renderHeader: CommonService.customRenderHeaderColumns
    }
  ];

  useEffect(() => {
    setIntialParamBodyApiCall(false);
    setTableLoadingStatus(true);
    manageUserPreferences
      .loadUserPreferences({
        body: {
          screenName: componentList[1].name.props.id,
          tabName: componentList[1].name.props.id,
          userId: 0,
          organization: {},
          entity: {}
        }
      })
      .then(response => {
        setIntialParamBodyApiCall(true);
        if (response.data === null) {
          setColumns(commonColumnForForecastTransmission);
          savePreference("visibility", commonColumnForForecastTransmission);
          paramBody.body.entity.erpEntityCode = defaultEntity;
          setParamBody({ ...paramBody });
        }
        //preference present in db
        else {
          var savedColumnsInResponse = JSON.parse(response.data.preferences);
          var orderedColumns = orderAndHideColumns(
            savedColumnsInResponse.columnsOrdervisible,
            commonColumnForForecastTransmission
          );
          setPinnedColumns(savedColumnsInResponse.columnsPinned);
          setColumns(orderedColumns);

          let poNumber = null;
          let bpCode = null;
          let bpName = null;
          let entityName = null;
          let createdBy = null;
          let createdTime = null;
          let updatedBy = null;
          let updatedTime = null;
          let emailSendDt = null;
          let msgStatusFlag = null;
          let fileReceivedDate = null;
          let approved = null;
          let approvedBy = null;
          let approvalDate = null;
          let wbsCode = null;
          let forecastDt = null;
          let revisionDt = null;
          let msgSentRemarks = null;
          let remarks = null;
          let fileName = null;
          let entityCode = null;
          let erpOrgCode = null;
          let fileReceivedfromDate = null;
          let fileReceivedtoDate = null;

          savedColumnsInResponse.columnsFilter.map(columns => {
            switch (columns.columnField) {
              case "poNumber":
                poNumber = columns.value;
                break;
              case "bpCode":
                bpCode = columns.value;
                break;
              case "bpName":
                bpName = columns.value;
                break;
              case "entityName":
                entityName = columns.value;
                break;
              case "createdBy":
                createdBy = columns.value;
                break;
              case "createdTime":
                createdTime = columns.value;
                break;
              case "updatedBy":
                updatedBy = columns.value;
                break;
              case "updatedTime":
                updatedTime = columns.value;
                break;
              case "emailSendDt":
                emailSendDt = columns.value;
                break;
              case "msgStatusFlag":
                msgStatusFlag = columns.value;
                break;
              case "fileReceivedDate":
                fileReceivedDate = columns.value;
                break;
              case "approved":
                approved = columns.value;
                break;
              case "approvedBy":
                approvedBy = columns.value;
                break;
              case "approvalDate":
                approvalDate = columns.value;
                break;
              case "wbsCode":
                wbsCode = columns.value;
                break;
              case "forecastDt":
                forecastDt = columns.value;
                break;
              case "revisionDt":
                revisionDt = columns.value;
                break;
              case "msgSentRemarks":
                msgSentRemarks = columns.value;
                break;
              case "remarks":
                remarks = columns.value;
                break;
              case "fileName":
                fileName = columns.value;
                break;
              case "entity.erpEntityCode":
                entityCode = columns.value;
                break;
              case "erpOrgCode":
                erpOrgCode = columns.value;
                break;
              case "fileReceivedfromDate":
                fileReceivedfromDate = columns.value;
                break;
              case "fileReceivedtoDate":
                fileReceivedtoDate = columns.value;
                break;
            }
          });

          setSearchedPoNo(poNumber);
          setSearchedEntityName(entityName);
          setSearchedCreatedBy(createdBy);
          setSearchedCreatedTime(createdTime);
          setSearchedUpdatedBy(updatedBy);
          setSearchedUpdatedTime(updatedTime);
          setSearchedEmailSentDate(emailSendDt);
          setSearchedMsgStatus(msgStatusFlag);
          setSearchedFileReceivedDate(fileReceivedDate);
          setSearchedApproved(approved);
          setSearchedApprovedBy(approvedBy);
          setSearchedApprovedDate(approvalDate);
          setSearchedWbsCode(wbsCode);
          setSearchedForecastDate(forecastDt);
          setSearchedRevisionDate(revisionDt);
          setSearchedMsgStatusRemarks(msgSentRemarks);
          setSearchedRemarks(remarks);
          setSearchedFileName(fileName);
          setsearchedBpCode(bpCode);
          setSearchedErpEntityCode(entityCode);
          setSearchedBillToCustomerName(bpName);
          setSearchedfileReceivedfromDate(fileReceivedfromDate);
          setSearchedfileReceivedtoDate(fileReceivedtoDate);

          var filterBody = {
            bpCode: bpCode,
            wbsCode: wbsCode,
            forecastDt: forecastDt,
            revisionDt: revisionDt,
            entity: {
              erpEntityCode: entityCode
            },
            bpCode: bpCode,
            bpName: bpName,
            poNumber: poNumber,
            msgStatusFlag:
              msgStatusFlag === "Not Sent"
                ? 0
                : msgStatusFlag === "Pending"
                ? 1
                : msgStatusFlag === "Successfully Sent"
                ? 2
                : msgStatusFlag === "Failed to Send"
                ? 3
                : msgStatusFlag === "Cancelled"
                ? 4
                : msgStatusFlag === "In-Queue"
                ? 6
                : msgStatusFlag === "In Progress"
                ? 7
                : "",
            createdDt: "",
            approved:
              approved === ""
                ? "All"
                : approved === "Not Approved"
                ? 0
                : approved === "Approved"
                ? 1
                : approved === "Rejected"
                ? 2
                : "",
            recordApprovedStatus:
              approved === ""
                ? "All"
                : approved === "Not Approved"
                ? 0
                : approved === "Approved"
                ? 1
                : approved === "Rejected"
                ? 2
                : "All",
            recordStatusFlag:
              msgStatusFlag === ""
                ? "All"
                : msgStatusFlag === "Not Sent"
                ? 0
                : msgStatusFlag === "Pending"
                ? 1
                : msgStatusFlag === "Successfully Sent"
                ? 2
                : msgStatusFlag === "Failed to Send"
                ? 3
                : msgStatusFlag === "Cancelled"
                ? 4
                : msgStatusFlag === "In-Queue"
                ? 6
                : msgStatusFlag === "In Progress"
                ? 7
                : "All",
            fileReceivedfromDate: fileReceivedfromDate,
            fileReceivedtoDate: fileReceivedtoDate
          };
          paramBody.body = filterBody;
          //default entity filter on no user preferences  filters in db
          if (savedColumnsInResponse.columnsFilter.length <= 0)
            paramBody.body.entity.erpEntityCode = defaultEntity;
          paramBody.sortDir = savedColumnsInResponse.columnsSort.sort;
          paramBody.sortKey = savedColumnsInResponse.columnsSort.field;
          setParamBody({ ...paramBody });

          if (savedColumnsInResponse.columnsFilter.length > 0)
            setSelectedFilters(savedColumnsInResponse.columnsFilter);
        }
      })
      .catch(function(error) {
        setTableLoadingStatus(false);
        setIntialParamBodyApiCall(true);
        if (error.response !== undefined) {
          setAlertBoxState({
            ...alertBoxState,
            openAlert: true,
            message: error.response.data.message,
            severity: "error"
          });
        }
      });
  }, [selectedLanguage]);

  useEffect(() => {
    if (intialParamBodyApiCall) {
      setTableLoadingStatus(true);
      setTableData([]);
      CommonService.GetListApi("/forecastTransmission", paramBody)
        .then(response => {
          setTotalRowCount(response.data.totalElements);
          setTableLoadingStatus(false);
          setTableData(response.data.content);
          response.data.totalElements > 0
            ? setChipInfoList(
                response.data.content[0].headerChipList === null
                  ? []
                  : response.data.content[0].headerChipList
              )
            : setChipInfoList([]);
        })
        .catch(function(error) {
          setTableLoadingStatus(false);
          if (error.response !== undefined) {
            setAlertBoxState({
              ...alertBoxState,
              openAlert: true,
              message: error.response.data.message,
              severity: "error"
            });
          }
        });
    }
  }, [paramBody, refreshTable]);

  useEffect(() => {
    if (totalRowCount === 0) {
      setDisiablingDownloadButtonForZeroRecords(true);
    } else {
      setDisiablingDownloadButtonForZeroRecords(false);
    }
  }, [totalRowCount]);

  const getDataBasedOnTheSelectedField = tableData.map(row => {
    return {
      bpCode: row.bpCode,
      entityCode: row.entity.erpEntityCode,
      approved: row.approved,
      msgId: row.msgHdrId
    };
  });

  const filterValueLoad = getDataBasedOnTheSelectedField.filter(item => {
    if (selectedRow.includes(item.msgId)) {
      return item;
    }
  });

  const bpCodeValues = filterValueLoad.map(row => {
    return row.bpCode;
  });
  const entittyCodeValue = filterValueLoad.map(row => {
    return row.erpEntityCode;
  });
  const filterValueApproved = filterValueLoad.map(row => {
    return row.approved;
  });

  const entityCodeColumn = columns.find(
    column => column.field === columnFieldsName.erpEntityCode
  );
  const entityCodeColIndex = columns.findIndex(
    col => col.field === columnFieldsName.erpEntityCode
  );

  const entityCodeFilterOperators = getGridStringOperators().map(operator => ({
    ...operator,
    InputComponent: CustomFilters.EntityCodeInputValue
  }));

  columns[entityCodeColIndex] = {
    ...entityCodeColumn,
    filterOperators: entityCodeFilterOperators
  };

  const wbsCodeColumn = columns.find(
    column => column.field === columnFieldsName.wbsCode
  );
  const wbsCodeColIndex = columns.findIndex(
    col => col.field === columnFieldsName.wbsCode
  );

  const wbsCodeFilterOperators = getGridStringOperators().map(operator => ({
    ...operator,
    InputComponent: CustomFilters.WbsCodeInputValue
  }));

  columns[wbsCodeColIndex] = {
    ...wbsCodeColumn,
    filterOperators: wbsCodeFilterOperators
  };

  const wbsNameColumn = columns.find(
    column => column.field === columnFieldsName.projectName
  );
  const wbsNameColIndex = columns.findIndex(
    col => col.field === columnFieldsName.projectName
  );

  const wbsNameFilterOperators = getGridStringOperators().map(operator => ({
    ...operator,
    InputComponent: CustomFilters.WbsDescriptionInputValue
  }));

  columns[wbsNameColIndex] = {
    ...wbsNameColumn,
    filterOperators: wbsNameFilterOperators
  };

  const fileReceivedfromDateColumn = columns.find(
    column => column.field === columnFieldsName.fileReceivedfromDate
  );
  const fileReceivedfromDateColIndex = columns.findIndex(
    col => col.field === columnFieldsName.fileReceivedfromDate
  );

  const fileReceivedFilterOperators = getGridDateOperators().map(operator => ({
    ...operator,
    InputComponent: CustomFilters.DateInputValue
  }));

  columns[fileReceivedfromDateColIndex] = {
    ...fileReceivedfromDateColumn,
    filterOperators: fileReceivedFilterOperators
  };

  const fileReceivedtoColumn = columns.find(
    column => column.field === columnFieldsName.fileReceivedtoDate
  );
  const fileReceivedtoColIndex = columns.findIndex(
    col => col.field === columnFieldsName.fileReceivedtoDate
  );

  const fileReceivedtoFilterOperators = getGridDateOperators().map(
    operator => ({
      ...operator,
      InputComponent: CustomFilters.DateInputValue
    })
  );

  columns[fileReceivedtoColIndex] = {
    ...fileReceivedtoColumn,
    filterOperators: fileReceivedtoFilterOperators
  };

  const fileReceivedDateColumn = columns.find(
    column => column.field === columnFieldsName.fileReceivedDate
  );
  const fileReceivedDateColIndex = columns.findIndex(
    col => col.field === columnFieldsName.fileReceivedDate
  );

  const fileReceivedDateFilterOperators = getGridDateOperators().map(
    operator => ({
      ...operator,
      InputComponent: CustomFilters.DateInputValue
    })
  );

  columns[fileReceivedDateColIndex] = {
    ...fileReceivedDateColumn,
    filterOperators: fileReceivedDateFilterOperators
  };

  const forecastDtColumn = columns.find(
    column => column.field === columnFieldsName.forecastDt
  );
  const forecastDtColIndex = columns.findIndex(
    col => col.field === columnFieldsName.forecastDt
  );

  const forecastDtFilterOperators = getGridDateOperators().map(operator => ({
    ...operator,
    InputComponent: CustomFilters.DateInputValue
  }));

  columns[forecastDtColIndex] = {
    ...forecastDtColumn,
    filterOperators: forecastDtFilterOperators
  };

  const revisionDtColumn = columns.find(
    column => column.field === columnFieldsName.revisionDt
  );
  const revisionDtColIndex = columns.findIndex(
    col => col.field === columnFieldsName.revisionDt
  );

  const revisionDtFilterOperators = getGridDateOperators().map(operator => ({
    ...operator,
    InputComponent: CustomFilters.DateInputValue
  }));

  columns[revisionDtColIndex] = {
    ...revisionDtColumn,
    filterOperators: revisionDtFilterOperators
  };

  function currentlySelectedRow(selections) {
    setSelectedRow(selections);
    if (selections.length === 0) {
      isDisableApproveButton(true);
      isDisableRejectionButton(true);
    } else {
      isDisableApproveButton(false);
      isDisableRejectionButton(false);
    }
  }

  useEffect(() => {
    if (selectedRow.length === 0) {
      isDisableApproveButton(true);
      isDisableRejectionButton(true);
    } else if (filterValueApproved.toString().includes("0")) {
      isDisableApproveButton(false);
      isDisableRejectionButton(false);
    } else if (filterValueApproved.toString().includes("1")) {
      isDisableApproveButton(true);
      isDisableRejectionButton(true);
    } else if (filterValueApproved.toString().includes("2")) {
      isDisableApproveButton(false);
      isDisableRejectionButton(true);
    } else {
      isDisableApproveButton(false);
      isDisableRejectionButton(false);
    }
  }, [filterValueApproved]);

  const showDownloadExcel = filePath => {
    const filePathReplaceWithDoubleBackwardSlash = filePath.replaceAll(
      "\\",
      "/"
    );
    const fileName = filePathReplaceWithDoubleBackwardSlash
      .split("/")
      [filePathReplaceWithDoubleBackwardSlash.split("/").length - 1].trim();
    fetch(
      `${process.env.REACT_APP_API_URL}/downloadFileFromServer?filePath=${filePathReplaceWithDoubleBackwardSlash}`,
      {
        method: "GET",
        headers: {
          authorization: "Bearer " + CommonService.getJwtTokenOfLoggedInUser()
        }
      }
    )
      .then(response => {
        return response.blob();
      })
      .then(blob => {
        setAlertBoxState({
          ...alertBoxState,
          openAlert: true,
          message: (
            <FormattedMessage
              id="successmessage.dowload"
              defaultMessage="File downloaded successfully"
            />
          ),
          severity: "success"
        });
        saveAs(blob, fileName);
      })
      .catch(error => {
        setAlertBoxState({
          ...alertBoxState,
          openAlert: true,
          message: (
            <FormattedMessage
              id="errorMessage.download"
              defaultMessage="Failed to download the file!"
            />
          ),
          severity: "error"
        });
      });
  };

  const onSubmit = () => {
    setIsFormSubmitted(true);
    setIsRowSentForApproval(true);
    setOpenBackDrop(true);
    if (filterValueApproved.toString().includes("1")) {
      setAlertBoxState({
        ...alertBoxState,
        openAlert: true,
        message: "Selected Records contains already Approved records",
        severity: "warning"
      });
      setIsRowSentForApproval(false);
      setIsFormSubmitted(false);
      setOpenBackDrop(false);
    } else {
      CommonService.saveOrUpdateOrPost("/fcApprovals", selectedRow)
        .then(response => {
          setIsFormSubmitted(false);
          setIsRowSentForApproval(false);
          setAlertBoxState({
            ...alertBoxState,
            openAlert: true,
            message: `MessageId : ${selectedRow} has been approved successfully`,
            severity: "success"
          });
          setSelectedRow([]);
          setRefreshTable(!refreshTable);
          isDisableApproveButton(true);
          setOpenBackDrop(false);
        })
        .catch(function(error) {
          setIsFormSubmitted(false);
          setAlertBoxState({
            ...alertBoxState,
            openAlert: true,
            message: error.response.message,
            severity: "error"
          });
          isDisableApproveButton(false);
          setOpenBackDrop(false);
        });
    }
  };

  const onSubmitReject = data => {
    setIsFormSubmitted(true);
    setIsRowSentForApproval(true);
    setOpenBackDrop(true);
    if (filterValueApproved.toString().includes("2")) {
      setAlertBoxState({
        ...alertBoxState,
        openAlert: true,
        message: "Selected Records contains already Rejected records",
        severity: "warning"
      });
      setIsRowSentForApproval(false);
      setIsFormSubmitted(false);
      setOpenBackDrop(false);
    } else if (filterValueApproved.toString().includes("1")) {
      setAlertBoxState({
        ...alertBoxState,
        openAlert: true,
        message: "Selected Records contains already Approved records",
        severity: "warning"
      });
      setIsRowSentForApproval(false);
      setIsFormSubmitted(false);
      setOpenBackDrop(false);
    } else {
      CommonService.saveOrUpdateOrPost("/fcRejections", selectedRow)
        .then(response => {
          setIsFormSubmitted(false);
          setAlertBoxState({
            ...alertBoxState,
            openAlert: true,
            message: `MessageId : ${selectedRow} has been rejected successfully`,
            severity: "success"
          });
          setSelectedRow([]);
          setRefreshTable(!refreshTable);
          isDisableRejectionButton(true);
          setOpenBackDrop(false);
        })
        .catch(function(error) {
          setIsFormSubmitted(false);
          setAlertBoxState({
            ...alertBoxState,
            openAlert: true,
            message: error.response.message,
            severity: "error"
          });
          isDisableRejectionButton(false);
          setOpenBackDrop(false);
        });
    }
  };

  const filterableColumns = useMemo(() => GetFilterableColumns(columns), [
    columns
  ]);

  const key = "columnField";

  const applyFilter = () => {
    let poNumber = null;
    let bpCode = null;
    let bpName = null;
    let entityName = null;
    let createdBy = null;
    let createdTime = null;
    let updatedBy = null;
    let updatedTime = null;
    let emailSendDt = null;
    let msgStatusFlag = null;
    let fileReceivedDate = null;
    let approved = null;
    let approvedBy = null;
    let approvalDate = null;
    let wbsCode = null;
    let forecastDt = null;
    let revisionDt = null;
    let msgSentRemarks = null;
    let remarks = null;
    let fileName = null;
    let entityCode = null;
    let erpOrgCode = null;
    let fileReceivedfromDate = null;
    let fileReceivedtoDate = null;

    selectedFilters.map(columns => {
      switch (columns.columnField) {
        case "poNumber":
          poNumber = columns.value;
          break;
        case "bpCode":
          bpCode = columns.value;
          break;
        case "bpName":
          bpName = columns.value;
          break;
        case "entityName":
          entityName = columns.value;
          break;
        case "createdBy":
          createdBy = columns.value;
          break;
        case "createdTime":
          createdTime = columns.value;
          break;
        case "updatedBy":
          updatedBy = columns.value;
          break;
        case "updatedTime":
          updatedTime = columns.value;
          break;
        case "emailSendDt":
          emailSendDt = columns.value;
          break;
        case "msgStatusFlag":
          msgStatusFlag = columns.value;
          break;
        case "fileReceivedDate":
          fileReceivedDate = columns.value;
          break;
        case "approved":
          approved = columns.value;
          break;
        case "approvedBy":
          approvedBy = columns.value;
          break;
        case "approvalDate":
          approvalDate = columns.value;
          break;
        case "wbsCode":
          wbsCode = columns.value;
          break;
        case "forecastDt":
          forecastDt = columns.value;
          break;
        case "revisionDt":
          revisionDt = columns.value;
          break;
        case "msgSentRemarks":
          msgSentRemarks = columns.value;
          break;
        case "remarks":
          remarks = columns.value;
          break;
        case "fileName":
          fileName = columns.value;
          break;
        case "entity.erpEntityCode":
          entityCode = columns.value;
          break;
        case "erpOrgCode":
          erpOrgCode = columns.value;
          break;
        case "fileReceivedfromDate":
          fileReceivedfromDate = columns.value;
          break;
        case "fileReceivedtoDate":
          fileReceivedtoDate = columns.value;
          break;
      }
    });
    setSearchedPoNo(poNumber);
    setSearchedEntityName(entityName);
    setSearchedCreatedBy(createdBy);
    setSearchedCreatedTime(createdTime);
    setSearchedUpdatedBy(updatedBy);
    setSearchedUpdatedTime(updatedTime);
    setSearchedEmailSentDate(emailSendDt);
    setSearchedMsgStatus(msgStatusFlag);
    setSearchedFileReceivedDate(fileReceivedDate);
    setSearchedApproved(approved);
    setSearchedApprovedBy(approvedBy);
    setSearchedApprovedDate(approvalDate);
    setSearchedWbsCode(wbsCode);
    setSearchedForecastDate(forecastDt);
    setSearchedRevisionDate(revisionDt);
    setSearchedMsgStatusRemarks(msgSentRemarks);
    setSearchedRemarks(remarks);
    setSearchedFileName(fileName);
    setsearchedBpCode(bpCode);
    setSearchedErpEntityCode(entityCode);
    setSearchedBillToCustomerName(bpName);
    setSearchedfileReceivedfromDate(fileReceivedfromDate);
    setSearchedfileReceivedtoDate(fileReceivedtoDate);

    savePreference(
      "filter",
      selectedFilters.length === 0 ? defaulSelectedFilters : selectedFilters
    );
    setParamBody(prevState => {
      return {
        ...prevState,
        body: {
          bpCode: bpCode,
          wbsCode: wbsCode,
          forecastDt: forecastDt,
          revisionDt: revisionDt,
          entity: {
            erpEntityCode: entityCode
          },
          bpCode: bpCode,
          bpName: bpName,
          poNumber: poNumber,
          msgStatusFlag:
            msgStatusFlag === "Not Sent"
              ? 0
              : msgStatusFlag === "Pending"
              ? 1
              : msgStatusFlag === "Successfully Sent"
              ? 2
              : msgStatusFlag === "Failed to Send"
              ? 3
              : msgStatusFlag === "Cancelled"
              ? 4
              : msgStatusFlag === "In-Queue"
              ? 6
              : msgStatusFlag === "In Progress"
              ? 7
              : "",
          createdDt: "",
          approved:
            approved === ""
              ? "All"
              : approved === "Not Approved"
              ? 0
              : approved === "Approved"
              ? 1
              : approved === "Rejected"
              ? 2
              : "",
          recordApprovedStatus:
            approved === ""
              ? "All"
              : approved === "Not Approved"
              ? 0
              : approved === "Approved"
              ? 1
              : approved === "Rejected"
              ? 2
              : "All",
          recordStatusFlag:
            msgStatusFlag === ""
              ? "All"
              : msgStatusFlag === "Not Sent"
              ? 0
              : msgStatusFlag === "Pending"
              ? 1
              : msgStatusFlag === "Successfully Sent"
              ? 2
              : msgStatusFlag === "Failed to Send"
              ? 3
              : msgStatusFlag === "Cancelled"
              ? 4
              : msgStatusFlag === "In-Queue"
              ? 6
              : msgStatusFlag === "In Progress"
              ? 7
              : "All",
          fileReceivedfromDate: fileReceivedfromDate,
          fileReceivedtoDate: fileReceivedtoDate
        }
      };
    });
  };

  useEffect(() => {
    if (intialParamBodyApiCall)
      setFilterCount(
        [...new Map(selectedFilters.map(item => [item[key], item])).values()]
          .length
      );
  }, [selectedFilters, tableData]);

  let filterBodyObj = {
    erpEntityCode: searchedErpEntityCode === null ? "" : searchedErpEntityCode,
    bpCode: searchedBpCode === null ? "" : searchedBpCode,
    wbsCode: searchedWbsCode === null ? "" : searchedWbsCode
    //fromFileReceivedDate: searchedFcFileRecievedFromDt=== null? "":searchedFcFileRecievedFromDt,
    //toFileReceivedDate: searchedFcFilereceivedToDt===null?"":searchedFcFilereceivedToDt
  };

  useEffect(() => {
    let colValDataObj = {};
    for (let key in filterBodyObj) {
      let value = filterBodyObj[key];
      if (
        filterBodyObj.hasOwnProperty(key) &&
        (value !== null && value !== undefined && value !== {})
      ) {
        colValDataObj[key] = value.toString();
      }
      setKeyValueData(colValDataObj);
    }
  }, [
    searchedShipToCustomerName,
    searchedShipmentNumber,
    searchedFromDt,
    searchedToDt,
    searchedApprovedRecordsRecords,
    searchedErpEntityCode,
    searchedMsgAsnSentFromDt,
    searchedMsgAsnSentToDt,
    searchedCommType,
    searchedMsgStatus,
    searchedBillToCustomerName,
    searchedShipmentCreatedByUserName,
    searchedBpCode
  ]);

  return (
    <React.Fragment>
      <CssBaseline />
      <Snackbar
        anchorOrigin={{ vertical, horizontal }}
        open={openAlert}
        onClose={handleCloseAlert}
        key={vertical + horizontal}
        autoHideDuration={6000}
      >
        <Alert onClose={handleCloseAlert} severity={severity}>
          {message}
        </Alert>
      </Snackbar>
      <CommonBackDrop open={openBackDrop} />
      {/* <CommonReportDownloadForMsg open={openReportDownloadDialog} bpType={bpTypeValue} bpCode={bpCodeValues} entityCode={entittyCodeValue} proccessValue={{ processId: 3, processName: 'Advance Shipment Note' }}
                onClose={closeReportDownloadDialog} msgIdvalue={selectedRow} /> */}
      <Grid container className={classes.rootForRole}>
        <Grid
          item
          container
          justifyContent="flex-start"
          alignItems="center"
          xs={12}
          sm={12}
          md={12}
          lg={12}
          className={classes.topGrid}
          style={{ marginLeft: "-0.5%" }}
        >
          <CustomBreadCrumb componentList={componentList} />
        </Grid>
        <CustomFilterComponent
          open={openFilterPanel}
          onClose={handleClose}
          filterableColumns={filterableColumns}
          setSelectedFilters={setSelectedFilters}
          selectedFilters={selectedFilters}
          applyFilter={applyFilter}
          defaulSelectedFilters={defaulSelectedFilters}
        />
        <ChipInfoList chipInfoList={chipInfoList} />
        <Paper
          elevation={3}
          style={{ marginTop: "5px" }}
          className={classes.gridHeightAndWidthForASN}
        >
          <div style={{ height: "100%", width: "100%" }}>
            <DataGridPro
              className={classes.customTableStyle}
              sortingMode="server"
              rows={tableData}
              columns={columns}
              showToolbar
              disableColumnFilter={true}
              pageSize={paramBody.recordsPerPage}
              loading={tableLoadingStatus}
              rowCount={totalRowCount}
              getRowId={row => row.fcId}
              scrollbarSize={30}
              rowsPerPageOptions={[1, 2, 10, 25, 50, 100]}
              pagination
              paginationMode="server"
              disableSelectionOnClick={true}
              disableMultipleColumnsSorting={true}
              isRowSelectable={params => true}
              hideFooter={true}
              //checkboxSelection={true}
              onSelectionModelChange={currentlySelectedRow}
              selectionModel={selectedRow}
              localeText={localtext}
              density="compact"
              components={{
                Toolbar: () => {
                  return (
                    <Grid
                      container
                      direction="row"
                      justifyContent="flex-start"
                      alignItems="center"
                      style={
                        mobileScreen
                          ? { marginBottom: "-0.1%", marginTop: "0%" }
                          : { marginBottom: "-0.3%", marginTop: "-0.5%" }
                      }
                    >
                      <Grid
                        item
                        container
                        direction="row"
                        justifyContent="flex-start"
                        xs={12}
                        sm={12}
                        md={6}
                        lg={6}
                      >
                        <Grid>
                          <Tooltip
                            title={
                              <FormattedMessage id="common.columntoolbar.tooltip" />
                            }
                            placement="bottom"
                          >
                            <GridToolbarColumnsButton
                              className={classes.toobarStyle}
                              variant="outlined"
                              size="medium"
                            />
                          </Tooltip>
                        </Grid>
                        <Grid>
                          <Tooltip
                            title={
                              <FormattedMessage id="common.density.tooltip" />
                            }
                            placement="bottom"
                          >
                            <GridToolbarDensitySelector
                              className={classes.toobarStyle}
                              variant="outlined"
                              size="medium"
                            />
                          </Tooltip>
                        </Grid>
                        <Grid>
                          <Tooltip
                            title={
                              <FormattedMessage id="common.toolbarfilterstooltipshow.toolbar.lable" />
                            }
                            placement="bottom"
                          >
                            <span>
                              <Button
                                className={classes.refreshToobarStyle}
                                variant="outlined"
                                size="medium"
                                onClick={() => setFilterPanel(true)}
                              >
                                <Badge
                                  color="primary"
                                  badgeContent={filterCount}
                                >
                                  <FilterListIcon />
                                </Badge>
                              </Button>
                            </span>
                          </Tooltip>
                        </Grid>
                        <Grid>
                          <Tooltip
                            title={
                              <FormattedMessage
                                id="common.button.refresh.tooltip"
                                defaultMessage="Refresh"
                              />
                            }
                            placement="bottom"
                          >
                            <span>
                              <Button
                                size="small"
                                color="primary"
                                variant="outlined"
                                className={classes.refreshToobarStyle}
                                onClick={() => {
                                  setRefreshTable(!refreshTable);
                                }}
                              >
                                <RefreshIcon />
                              </Button>
                            </span>
                          </Tooltip>
                        </Grid>
                        {/* <Grid>
                          <Tooltip
                            title={
                              <FormattedMessage
                                id="common.button.approveselectedrecords.tooltip"
                                defaultMessage="Approve selected records"
                              />
                            }
                            placement="bottom"
                          >
                            <span>
                              {(advanceShipmentNoteOutboundModuleAccess !==
                              undefined
                                ? advanceShipmentNoteOutboundModuleAccess.editFlag ||
                                  advanceShipmentNoteOutboundModuleAccess.createFlag
                                : false) && (
                                <Button
                                  size="small"
                                  color="primary"
                                  variant="outlined"
                                  className={classes.refreshToobarStyle}
                                  onClick={onSubmit}
                                  disabled={
                                    disableApproveButton || isFormSubmitted
                                  }
                                >
                                  <IconApproval size={20} />
                                </Button>
                              )}
                            </span>
                          </Tooltip>
                        </Grid> */}
                        {/* <Grid>
                          <Tooltip
                            title={
                              <FormattedMessage
                                id="common.button.rejectselectedrecords.tooltip"
                                defaultMessage="Reject selected records"
                              />
                            }
                            placement="bottom"
                          >
                            <span>
                              {(advanceShipmentNoteOutboundModuleAccess !==
                              undefined
                                ? advanceShipmentNoteOutboundModuleAccess.editFlag ||
                                  advanceShipmentNoteOutboundModuleAccess.createFlag
                                : false) && (
                                <Button
                                  size="small"
                                  color="primary"
                                  variant="outlined"
                                  className={classes.refreshToobarStyle}
                                  onClick={onSubmitReject}
                                  disabled={
                                    disableRejectionButton || isFormSubmitted
                                  }
                                >
                                  <CancelIcon size={20} />
                                </Button>
                              )}
                            </span>
                          </Tooltip>
                        </Grid> */}
                        {/* <Grid>
                          <Tooltip
                            title={
                              <FormattedMessage id="common.tooltip.breadcrumb.downloadExcelForMsg" />
                            }
                            placement="bottom"
                          >
                            <span>
                              {(advanceShipmentNoteOutboundModuleAccess !==
                              undefined
                                ? advanceShipmentNoteOutboundModuleAccess.readFlag
                                : false) && (
                                <Button
                                  size="small"
                                  color="primary"
                                  variant="outlined"
                                  className={classes.refreshToobarStyle}
                                  onClick={() => {
                                    setMsgHdrPopUp(true);
                                  }}
                                  disabled={
                                    disiablingDownloadButtonForZeroRecords
                                  }
                                >
                                  <GetAppIcon size={20} />
                                </Button>
                              )}
                            </span>
                          </Tooltip>
                        </Grid> */}
                      </Grid>
                      <Grid item xs={12} sm={12} md={6} lg={6}>
                        <CommonGridPagination />
                      </Grid>
                    </Grid>
                  );
                }
              }}
              hideFooterSelectedRowCount={true}
              onPageSizeChange={pageParams => {
                setParamBody(prevState => {
                  return { ...prevState, recordsPerPage: pageParams };
                });
              }}
              onPageChange={pageParams => {
                setParamBody(prevState => {
                  return { ...prevState, pageNo: pageParams };
                });
              }}
              pinnedColumns={pinnedColumns}
              onPinnedColumnsChange={params => {
                var OrderedColumns = columns;
                if (
                  pinnedColumns.left.length > params.left.length &&
                  pinnedColumns.right.length < params.right.length
                ) {
                  var unpinnedColumns = pinnedColumns.left.filter(
                    x => params.left.indexOf(x) === -1
                  );
                  var index = OrderedColumns.findIndex(
                    element => element.field === unpinnedColumns[0]
                  );
                  var reOrderedColumns = OrderedColumns.splice(index, 1);
                  OrderedColumns.splice(
                    OrderedColumns.length,
                    0,
                    reOrderedColumns[0]
                  );
                } else if (
                  pinnedColumns.right.length > params.right.length &&
                  pinnedColumns.left.length < params.left.length
                ) {
                  var unpinnedColumns = pinnedColumns.right.filter(
                    x => params.right.indexOf(x) === -1
                  );
                  var index = OrderedColumns.findIndex(
                    element => element.field === unpinnedColumns[0]
                  );
                  var reOrderedColumns = OrderedColumns.splice(index, 1);
                  OrderedColumns.splice(
                    pinnedColumns.left.length - 1,
                    0,
                    reOrderedColumns[0]
                  );
                } else if (pinnedColumns.left.length < params.left.length) {
                  var index = OrderedColumns.findIndex(
                    element =>
                      element.field === params.left[params.left.length - 1]
                  );
                  var reOrderedColumns = OrderedColumns.splice(index, 1);
                  OrderedColumns.splice(
                    pinnedColumns.left.length - 1,
                    0,
                    reOrderedColumns[0]
                  );
                } else if (pinnedColumns.right.length < params.right.length) {
                  var index = OrderedColumns.findIndex(
                    element =>
                      element.field === params.right[params.right.length - 1]
                  );
                  var reOrderedColumns = OrderedColumns.splice(index, 1);
                  OrderedColumns.splice(
                    OrderedColumns.length,
                    0,
                    reOrderedColumns[0]
                  );
                } else if (pinnedColumns.right.length > params.right.length) {
                  var unpinnedColumns = pinnedColumns.right.filter(
                    x => params.right.indexOf(x) === -1
                  );
                  var index = OrderedColumns.findIndex(
                    element => element.field === unpinnedColumns[0]
                  );
                  var reOrderedColumns = OrderedColumns.splice(index, 1);
                  OrderedColumns.splice(
                    -params.right.length,
                    0,
                    reOrderedColumns[0]
                  );
                } else if (pinnedColumns.left.length > params.left.length) {
                  var unpinnedColumns = pinnedColumns.left.filter(
                    x => params.left.indexOf(x) === -1
                  );
                  var index = OrderedColumns.findIndex(
                    element => element.field === unpinnedColumns[0]
                  );
                  var reOrderedColumns = OrderedColumns.splice(index, 1);
                  OrderedColumns.splice(
                    params.left.length - 1,
                    0,
                    reOrderedColumns[0]
                  );
                }
                savePreference(
                  "pinned",
                  {
                    left: params.left,
                    right: params.right
                  },
                  OrderedColumns
                );
              }}
              onColumnVisibilityChange={params => {
                if (params.field !== "__check__") {
                  var visibleColumns = columns;
                  var index = visibleColumns.findIndex(
                    element => element.field === params.field
                  );
                  visibleColumns[index].hide = !params.isVisible;
                  savePreference("visibility", visibleColumns);
                }
              }}
              onColumnOrderChange={params => {
                --params.oldIndex;
                --params.targetIndex;
                var OrderedColumns = columns;
                var reOrderedColumns = OrderedColumns.splice(
                  params.oldIndex,
                  1
                );
                OrderedColumns.splice(
                  params.targetIndex,
                  0,
                  reOrderedColumns[0]
                );
                savePreference("order", OrderedColumns);
              }}
              onSortModelChange={params => {
                let sortModel = params[0];
                var previousParamBody = paramBody;
                if (
                  sortModel !== undefined &&
                  !(
                    previousParamBody.sortDir === sortModel.sort &&
                    previousParamBody.sortKey === sortModel.field
                  )
                ) {
                  setParamBody({
                    ...paramBody,
                    sortDir: sortModel.sort,
                    sortKey: sortModel.field
                  });
                  savePreference("sort", params[0]);
                } else if (
                  sortModel === undefined &&
                  !(
                    previousParamBody.sortDir === null &&
                    previousParamBody.sortKey === null
                  )
                ) {
                  setParamBody({ ...paramBody, sortDir: null, sortKey: null });
                  savePreference("sort", { field: null, sort: null });
                }
              }}
              sortModel={[
                {
                  field: paramBody.sortKey,
                  sort: paramBody.sortDir
                }
              ]}
              sortingOrder={["desc", "asc"]}
              filterMode="server"
              onFilterModelChange={async params => {
                let filterModelItem = params.items;
                if (filterModelItem.length > 0) {
                  let bpCode = null;
                  let fileReceivedDate = null;
                  let revisionDt = null;
                  let createdDt = null;
                  let updatedTime = null;
                  let forecastDt = null;
                  let emailSendDt = null;

                  for (let index = 0; index < filterModelItem.length; index++) {
                    if (
                      filterModelItem[index].columnField ===
                      columnFieldsName.fileReceivedDate
                    ) {
                      fileReceivedDate =
                        (await filterModelItem[index].value) === undefined
                          ? ""
                          : JSON.parse(filterModelItem[index].value).value;
                      break;
                    }
                  }
                  for (let index = 0; index < filterModelItem.length; index++) {
                    if (
                      filterModelItem[index].columnField ===
                      columnFieldsName.revisionDt
                    ) {
                      revisionDt =
                        (await filterModelItem[index].value) === undefined
                          ? ""
                          : JSON.parse(filterModelItem[index].value).value;
                      break;
                    }
                  }
                  for (let index = 0; index < filterModelItem.length; index++) {
                    if (
                      filterModelItem[index].columnField ===
                      columnFieldsName.createdDt
                    ) {
                      createdDt =
                        (await filterModelItem[index].value) === undefined
                          ? ""
                          : filterModelItem[index].value;
                      break;
                    }
                  }
                  for (let index = 0; index < filterModelItem.length; index++) {
                    if (
                      filterModelItem[index].columnField ===
                      columnFieldsName.updatedTime
                    ) {
                      updatedTime =
                        (await filterModelItem[index].value) === undefined
                          ? ""
                          : filterModelItem[index].value;
                      break;
                    }
                  }
                  for (let index = 0; index < filterModelItem.length; index++) {
                    if (
                      filterModelItem[index].columnField ===
                      columnFieldsName.forecastDt
                    ) {
                      forecastDt =
                        (await filterModelItem[index].value) === undefined
                          ? ""
                          : filterModelItem[index].value;
                      break;
                    }
                  }
                  for (let index = 0; index < filterModelItem.length; index++) {
                    if (
                      filterModelItem[index].columnField ===
                      columnFieldsName.emailSendDt
                    ) {
                      emailSendDt =
                        (await filterModelItem[index].value) === undefined
                          ? ""
                          : filterModelItem[index].value;
                      break;
                    }
                  }
                  for (let index = 0; index < filterModelItem.length; index++) {
                    if (
                      filterModelItem[index].columnField ===
                      columnFieldsName.forecastDt
                    ) {
                      forecastDt = await (filterModelItem[index].value !==
                        undefined &&
                      filterModelItem[index].value !== null &&
                      filterModelItem[index].value !== "null"
                        ? filterModelItem[index].value
                        : null);
                      break;
                    }
                  }

                  setSearchedCreatedTime(createdDt);
                  setsearchedBpCode(bpCode);
                  setSearchedFileReceivedDate(fileReceivedDate);
                  setSearchedEmailSentDate(emailSendDt);
                  setSearchedUpdatedTime(updatedTime);
                  setSearchedRevisionDate(revisionDt);
                  setSearchedForecastDate(forecastDt);
                }
              }}
            />
          </div>
        </Paper>
      </Grid>
    </React.Fragment>
  );
}

export default ForecastTransmission;
